export default __webpack_public_path__ + "images/a9accbcc6f3472ee6d0ee7cedc302827.svg";